import Service from './partner-info.service';
import HomeService from '@/views/home/service.js';
export default {
  data: () => {
    return {
      info: {},
      status: 'init'
    };
  },
  created() {
    HomeService.getUserBaseInfo().then(res => {
      Service.getPartnerInfoByName({ orgName: res.data.companyName, tId: '66aaf784247b9fffdb5eba0b', type: 'arongqi'}).then(res => {
        this.info = res;
      }).finally(() => {
        this.status = 'end';
      });
    });
  },
  methods: {
    toDetail() {
      this.$router.push('/socialized-service/partner/partner-detail?id=' + this.info._id + '&type=all');
    },
    toEdit() {
      this.$router.push('/socialized-service/partner/fileprepare?id=' + this.info._id);
    }
  }
};
